(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wb-mobile-product-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = () => {
    const intro = document.querySelector('[data-wb-mobile-product-intro]');
    const bar = document.querySelector('[data-wb-mobile-product-bar]');
    if (!intro || !bar || document.querySelector('.wd-mobile-buybar')) return;

    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const configurations = [
      {
        root: '.wb-custom-product',
        hero: '.wb-custom-product__main-media',
        purchase: '.wb-custom-product__purchase',
        title: '.wb-custom-product__title',
        price: '.wb-custom-product__current-price',
        priceHide: '.wb-custom-product__price',
        movePurchase: true
      },
      {
        root: '.wb-table-number',
        hero: '.wb-table-number__main-media',
        purchase: '.wb-table-number__purchase',
        title: '.wb-table-number__title',
        price: '.wb-table-number__current-price',
        priceHide: '.wb-table-number__price',
        movePurchase: true
      },
      {
        root: '.wb-splashback',
        hero: '.wb-gallery__main',
        purchase: '.wb-splashback__info',
        title: '.wb-splashback__title',
        price: '[data-wb-price]',
        priceHide: '[data-wb-price]',
        movePurchase: true
      },
      {
        root: '.wbpt',
        hero: '.wbpt-stage',
        purchase: '.wbpt-buy',
        title: '.wbpt-buy h1',
        price: '[data-total]',
        priceHide: '',
        movePurchase: true
      },
      {
        root: '.wbpn',
        hero: '.wbpn__main-image',
        purchase: '.wbpn__details',
        title: '.wbpn__details h1',
        price: '[data-pn-head-price]',
        priceHide: '.wbpn__price',
        movePurchase: true
      },
      {
        root: '.wbns',
        hero: '.wbns-hero',
        purchase: '.wbns-order',
        title: '.wbns-order h1',
        price: '[data-ns-price]',
        priceHide: '.wbns-price-row',
        movePurchase: true
      },
      {
        root: '.wolfborn-product-page',
        hero: '.product__info-block--gallery .slider-component__inner',
        purchase: '.product__info-aside',
        title: '.product__title',
        price: '.product__info-aside .product__price',
        priceHide: '.product__info-block--price, .product__title--price',
        movePurchase: false
      }
    ];

    const config = configurations.find(item => {
      const root = document.querySelector(item.root);
      return root && root.querySelector(item.hero) && root.querySelector(item.purchase);
    });

    if (!config) return;

    const root = document.querySelector(config.root);
    const hero = root.querySelector(config.hero);
    const purchase = root.querySelector(config.purchase);
    const title = root.querySelector(config.title);
    const priceFallback = intro.dataset.priceFallback || '';
    const placeholder = document.createComment('wb-mobile-purchase-placeholder');
    purchase.parentNode.insertBefore(placeholder, purchase);

    if (title) title.classList.add('wb-mobile-product-original-title');
    if (config.priceHide) {
      root.querySelectorAll(config.priceHide).forEach(node => {
        node.classList.add('wb-mobile-product-original-price');
      });
    }

    const hasPurchaseAction = () => Boolean(
      purchase.querySelector('form[action*="/cart/add"]') ||
      purchase.querySelector('[data-ns-buy], [data-pn-submit], [data-wb-add], [name="add"], .wd-add')
    );

    let scheduled = false;
    const syncPrice = () => {
      scheduled = false;
      const source = root.querySelector(config.price);
      let value = source?.textContent?.replace(/\s+/g, ' ').trim() || '';
      if (!value || value === '—' || /^loading/i.test(value)) value = priceFallback;
      if (!value) return;
      const introPrice = intro.querySelector('[data-wb-mobile-product-intro-price]');
      const barPrice = bar.querySelector('[data-wb-mobile-product-bar-price]');
      if (introPrice) introPrice.textContent = value;
      if (barPrice) barPrice.textContent = value;
    };

    const schedulePriceSync = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(syncPrice);
    };

    const observer = new MutationObserver(schedulePriceSync);
    observer.observe(purchase, { subtree: true, childList: true, characterData: true });
    root.addEventListener('change', schedulePriceSync, true);
    root.addEventListener('input', schedulePriceSync, true);

    const apply = () => {
      if (mediaQuery.matches) {
        hero.insertAdjacentElement('afterend', intro);
        if (config.movePurchase) intro.insertAdjacentElement('afterend', purchase);
        intro.hidden = false;
        intro.classList.add('is-active');
        if (hasPurchaseAction()) {
          bar.hidden = false;
          bar.classList.add('is-active');
        } else {
          bar.hidden = true;
          bar.classList.remove('is-active');
        }
        syncPrice();
      } else {
        if (placeholder.parentNode) {
          placeholder.parentNode.insertBefore(purchase, placeholder.nextSibling);
        }
        intro.hidden = true;
        intro.classList.remove('is-active');
        bar.hidden = true;
        bar.classList.remove('is-active');
      }
    };

    bar.querySelector('[data-wb-mobile-product-bar-action]')?.addEventListener('click', () => {
      purchase.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    });

    mediaQuery.addEventListener('change', apply);
    apply();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
